import React from 'react';
import {useIntelligenceRequests} from '../../../../../firebase/firestore/useIntelligenceRequests';
import {Stack, Typography} from "@mui/material";
import {useNavigate} from 'react-router';

const IRList = () => {
    const {data: requests, loading, error} = useIntelligenceRequests();
    const navigate = useNavigate();

    if (loading) return <div>Loading intelligence requests…</div>;
    if (error) return <div style={{color: 'red'}}>Error loading intelligence
        requests: {String(error?.message || error)}</div>;
    if (!requests || requests.length === 0) return <div>No intelligence requests found.</div>;

    return (
        <Stack spacing={2}>
            {requests.map(r => (
                <Stack
                    key={r.id}
                    p={2}
                    spacing={1}
                    border="1px solid #ddd"
                    bgcolor={'white'}
                    borderRadius={2}
                    onClick={() => navigate(`/IR/${r.id}`)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') navigate(`/IR/${r.id}`);
                    }}
                    sx={{
                        cursor: 'pointer',
                        '&:hover': {borderColor: 'black'}
                    }}
                >

                    <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                        <Typography variant={'h6'} fontWeight={600}>{r.title}</Typography>
                        <Typography variant={'subtitle2'} color={'gray'}>ID: {r.id}</Typography>
                    </Stack>

                    <Stack direction={'row'} spacing={2}>
                        <Typography><strong>Priority:</strong> {r.priority}</Typography>
                        <Typography><strong>Status:</strong> {r.status}</Typography>
                    </Stack>

                    <Typography sx={{whiteSpace: 'pre-line'}}>{r.fullQuestion}</Typography>
                </Stack>
            ))}
        </Stack>
    );
};

export default IRList;